import { getRegionDetect } from '@/service/region'
import { type FregionRegionDetectData, type RegionDetectParams } from '@/view-models/region'

export const useRegionStore = defineStore('region', () => {
  const nuxtApp = useNuxtApp()
  const { $axios } = nuxtApp

  const regionDetectInfo = ref<FregionRegionDetectData>()

  const fetchRegionDetect = async ({ ip, timeZone }: RegionDetectParams) => {
    try {
      const { data } = await getRegionDetect($axios, { ip, timeZone })
      regionDetectInfo.value = data
      return data
    } catch (error) {
      console.error('fetchRegionDetect error: ', error)
    }
  }

  return {
    regionDetectInfo,
    fetchRegionDetect,
  }
})
